import MyCheckIns from "./index";

/** Deep link: /my-check-ins/performance opens My Check-Ins on the Performance tab */
const MyCheckInsPerformance = () => <MyCheckIns defaultTab="performance" />;

export default MyCheckInsPerformance;
